import { LayoutModule } from '@angular/cdk/layout';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { HomePageCardComponent } from '../shared/components/home-page-card/home-page-card.component';
import { BreadCrumbViewComponent } from '../shared/components/layout-related-components/bread-crumb-view/bread-crumb-view.component';
import { GoToAdminButtonComponent } from '../shared/components/layout-related-components/go-to-admin-button/go-to-admin-button.component';
import { NotificationOpenerIconComponent } from '../shared/components/layout-related-components/notification-opener-icon/notification-opener-icon.component';
import { ProfileDetailsMenuViewComponent } from '../shared/components/layout-related-components/profile-details-menu-view/profile-details-menu-view.component';
import { SharedModule } from '../shared/shared.module';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { CommonLayoutComponent } from './common-layout/common-layout.component';
import { DOLayoutRoutingModule } from './do-layout-routing.module';
import { HomePageComponent } from './home-page/home-page.component';
import { InnactiveOrganisationComponent } from './innactive-organisation/innactive-organisation.component';
import { InnactiveUserComponent } from './innactive-user/innactive-user.component';
import { LicenseErrorComponent } from './license-error/license-error.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotificationComponent } from './notification/notification.component';
import { RegisterComponent } from './register/register.component';
import { SubscriptionDetailsComponent } from './subscription-details/subscription-details.component';
import { SupportUserDetailsComponent } from './support-user-details/support-user-details.component';
import { TermsAndConditionComponent } from './terms-and-condition/terms-and-condition.component';
import { DxButtonGroupModule, DxButtonModule, DxCheckBoxModule, DxFormModule, DxGalleryModule, DxPopoverModule, DxPopupModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule, DxTooltipModule, DxValidatorModule } from 'devextreme-angular';
import { OrganisationSettingsButtonComponent } from '../shared/components/layout-related-components/organisation-settings-button/organisation-settings-button.component';
import { AddOrganisationComponent } from './home-page/add-organisation/add-organisation.component';
import { RegistrationComponent } from './registration/registration.component';
import { CustomStepperComponent } from '../shared/components/custom-stepper/custom-stepper.component';
import { PlanCardComponent } from "../shared/components/plan-card/plan-card.component";
import { LicenseAgreementComponent } from '../modules/settings/components/organisation-settings-manager/license-agreement/license-agreement.component';
import { NewOrganisationComponent } from './new-organisation/new-organisation.component';
import { PlanSelectorComponent } from "./plan-selector/plan-selector.component";
import { AppSelectorComponent } from './app-selector/app-selector.component';
import { PurchaseNewProductComponent } from './home-page/purchase-new-product/purchase-new-product.component';
import { SketchVariantSelectorComponent } from './sketch-variant-selector/sketch-variant-selector.component';
import { SelectedAppDescriptionComponent } from './selected-app-description/selected-app-description.component';
import { PurchaseNewAppComponent } from './home-page/purchase-new-app/purchase-new-app.component';
import { PaymentInfoComponent } from './home-page/payment-info/payment-info.component';
import { EmptyStateComponent } from '../shared/components/empty-state/empty-state.component';

@NgModule({
    declarations: [
        CommonLayoutComponent,
        SubscriptionDetailsComponent,
        AccessDeniedComponent,
        NotFoundComponent,
        LicenseErrorComponent,
        InnactiveOrganisationComponent,
        InnactiveUserComponent,
        SupportUserDetailsComponent,
        RegisterComponent,
        HomePageComponent,
        TermsAndConditionComponent,
        AddOrganisationComponent,
        PurchaseNewProductComponent,
        SketchVariantSelectorComponent,
        RegistrationComponent,
        SelectedAppDescriptionComponent,
        NewOrganisationComponent,
        PurchaseNewAppComponent,
        PaymentInfoComponent
    ],
    imports: [
    CommonModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    RouterModule,
    MatSlideToggleModule,
    MatTooltipModule,
    DOLayoutRoutingModule,
    SharedModule,
    PortalModule,
    HomePageCardComponent,
    BreadCrumbViewComponent,
    GoToAdminButtonComponent,
    ProfileDetailsMenuViewComponent,
    NotificationComponent,
    NotificationOpenerIconComponent,
    OrganisationSettingsButtonComponent,
    DxGalleryModule,
    DxFormModule,
    DxTextAreaModule,
    DxButtonGroupModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    CustomStepperComponent,
    PlanCardComponent,
    LicenseAgreementComponent,
    DxValidatorModule,
    PlanSelectorComponent,
    DxTooltipModule,
    DxPopoverModule,
    DxPopupModule,
    DxCheckBoxModule,
    AppSelectorComponent,
    EmptyStateComponent
],
    exports: [
        CommonLayoutComponent
    ]
})
export class DOLayoutModule { }
